import { RestApiSenderConfig } from 'ihub/common';
import { AdvancedTourStep } from '../shared-types';
import { TaskTourProps } from './task-tour-props';

export function getRestApiSenderTourSteps({
	defaultStyles,
	microTaskConfigType,
}: Readonly<TaskTourProps>): AdvancedTourStep[] {
	if (!microTaskConfigType) return [];
	const config = microTaskConfigType as RestApiSenderConfig;

	return [
		{
			id: 'http-method',
			selector: '[data-tour="http-method"]',
			content:
				'Required: This is used to select the http method for the API request that will be sent. Standard methods such as GET, POST, PUT etc. is used in the task.',
		},
		{
			id: 'http-protocol',
			selector: '[data-tour="http-protocol"]',
			content: 'Required: Sets whether the request should be made using HTTPS or HTTP.',
		},
		{
			id: 'http-url',
			selector: '[data-tour="http-url"]',
			content: 'Required: This is where the endpoint can be set which the API will be sent to.',
		},
		{
			id: 'preview-url',
			selector: '[data-tour="preview-url"]',
			content:
				'Read-only: This is a read-only field where your final API endpoint will be populated from your set URL and Query parameters.',
		},
		{
			id: 'keep-input',
			selector: '[data-tour="keep-input"]',
			content:
				'If this option is checked, the result data will be combined with the input record for the related request.',
		},
		{
			id: 'enable-retries',
			selector: '[data-tour="enable-retries"]',
			content:
				'If this option is checked the task will automatically attempt to retry the REST request.',
		},
		...(config.enableRetries
			? [
					{
						id: 'retry-limit',
						selector: '[data-tour="retry-limit"]',
						content: 'The amount of times the task will retry to send the request.',
					},
					{
						id: 'retry-delay',
						selector: '[data-tour="retry-delay"]',
						content: 'A delay time in ms. This will set the time to wait between retries.',
					},
				]
			: []),
		{
			id: 'include-response-headers',
			selector: '[data-tour="include-response-headers"]',
			content:
				'If this option is checked the HTTP headers taken from the response will be included in the output data.',
		},
		{
			id: 'accordion',
			selector: '[data-tour="accordion"]',
			content:
				'Additional configuration settings for the rest API sender task, each individual accordion has its own in-depth tutorial.',
		},

		{
			id: 'auth',
			selector: '[data-tour="auth"]',
			content: 'Adjust the request authentication for the task.',
		},
		{
			id: 'headers',
			selector: '[data-tour="headers"]',
			content: 'Adjust the request headers for the task.',
		},
		{
			id: 'params',
			selector: '[data-tour="params"]',
			content: 'Adjust the request query parameters for the task.',
		},
		{
			id: 'body',
			selector: '[data-tour="body"]',
			content: 'Adjust the request body (payload) for the task.',
		},
	].map(tourItem => ({ ...tourItem, styles: defaultStyles }));
}
